<div class="region-feature">
    <fieldset class="flex-row center-align">
        <div class="flex-column grow space-right-30">
            <label class="label-title" [i18n]="[{target: 'innerHTML', key: i18nKeyNode + '.title'}]"></label>
            <span class="dspl-block inner-space-top-8">
                <i class="fa fa-info-circle space-right-5"></i>
                <span [i18n]="[{target: 'innerHTML', key: i18nKeyNode + '.sub-title'}]"></span>
            </span>
        </div>

        <div class="flex-row no-shrink">
            <app-switcher
                [labelKey]="i18nKeyNode + '.activation.label'"
                [(ngModel)]="available"
                (ngModelChange)="updateFeature()"
                name="{{name + '-available'}}}"
                class="space-right-25">
            </app-switcher>
            <app-switcher
                [disabled]="!available"
                [labelKey]="i18nKeyNode + '.checkbox'"
                [(ngModel)]="forced"
                (ngModelChange)="updateFeature()"
                name="{{name + '-forced'}}">
            </app-switcher>
        </div>
    </fieldset>
</div>
